import React from "react";

export default function Badge({ active }) {
  return (
    <span className={`pm-badge ${active ? "pm-badge--active" : "pm-badge--inactive"}`}>
      <span className="pm-badge__dot" />
      {active ? "Active" : "Inactive"}
    </span>
  );
}
